import { Pleading } from './pleading';
import { JuvenileCase } from './../juvenile-case';
import { Party } from './party';
import { SafeJSON } from './../../shared/safe-json';

export class Issue {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
    }

    getIssueKey(): string {
        return this.key;
    }

    getPleadingDate(): string {
        return SafeJSON.get('juvenilePleading.pleadingDate', this.json);
    }

    getPleadingTime(): string {
        return SafeJSON.get('juvenilePleading.pleadingTime', this.json);
    }

    getPleadingType(): string {
        return SafeJSON.get('juvenilePleading.pleadingType', this.json);
    }

    getPleadingTypeCode(): string {
        return SafeJSON.get('juvenilePleading.pleadingTypeCode', this.json);
    }

    getPleadingTypeDesc(): string {
        return SafeJSON.get('juvenilePleading.pleadingTypeDesc', this.json);
    }

    getAllegationDescription(): string {
        return SafeJSON.get('description', this.json);
    }

    getAllegationOffenseDate(): string {
        return SafeJSON.get('offenseDate', this.json);
    }

    getAllegationOffenseTime(): string {
        return SafeJSON.get('dispTimestamp', this.json);
    }

    getIssueRowKey(): string {
        return SafeJSON.get('rowKey', this.json);
    }
    getOrderRef(issue: any): string {
        return SafeJSON.get('issueOrderPartyRef.orderRef', issue);
    }
    getPleadingKey(): string {
        return SafeJSON.get('pleadingKey', this.json);
    }
    getPleadingClockedInDate(juvenileCase: JuvenileCase): string {
        const pleadingKey = this.getPleadingKey();
        const pleading: Pleading = juvenileCase.getPleadingByKey(pleadingKey);
        return pleading.getClockDate();
    }
    getPleadingDescription(juvenileCase: JuvenileCase): string {
        const pleadingKey = this.getPleadingKey();
        const pleading: Pleading = juvenileCase.getPleadingByKey(pleadingKey);
        return pleading.getPleadingTypeDescription();
    }
    getAbstractRefKey(): string {
        const exists = SafeJSON.get('issueOrderPartyRef', this.json);
        if (exists === '') {
            return '-';
        }
        const partyList: Object [] = this.json.issueOrderPartyRef;
        const length = partyList.length;

        for (let i = 0; i < length; i++) {
            const abstractRef: string = SafeJSON.get('abstractRef', this.json.issueOrderPartyRef[i]);
            if (abstractRef !== '') {
                return abstractRef;
            }
        }
        return '';
    }
    getType(): string {
        return SafeJSON.get('issueType.description', this.json);
    }
    getIssuePartyCodes(): string[] {
        return SafeJSON.get('issuePartyCodes', this.json);
    }
    getIssueStatus(): string {
        const result = SafeJSON.get('status', this.json);
        if (result === '' || result === ' ') {
            return '';
        }
        return '(' + result + ')';
    }
    getIssueAppealed(juvenileCase: JuvenileCase): string {
        const APPEALED_TEXT = '(Appealed – See Transfers and Appeals)';
        if (juvenileCase.getCaseType() === 'CVM') {
            const appealedSection = SafeJSON.getWithDefault('appealTo', juvenileCase.json);
            if (appealedSection !== '-') {
                return APPEALED_TEXT;
            }
        }
        const result: any[] = SafeJSON.get('appealsRef', this.json);
        if (result === undefined || result.length === 0) {
            return '';
        }
        return APPEALED_TEXT;
    }
    getIssueOrderPartyRole(party: any): string {
        const exists = SafeJSON.get('issueOrderPartyRef', this.json);
        if (exists === '') {
            return '-';
        }
        const partyList: Object [] = this.json.issueOrderPartyRef;
        const length = partyList.length;

        for (let i = 0; i < length; i++) {
            const casePartyRef: string = SafeJSON.get('casePartyRef', this.json.issueOrderPartyRef[i]);
            if (party.getPartyKey() === casePartyRef) {
                return SafeJSON.getWithDefault('issueOrderPartyRole.description', this.json.issueOrderPartyRef[i]);
            }
        }
        return '';
    }
    getIssueIndexedOnDate(party: any): string {
        const exists = SafeJSON.get('issueOrderPartyRef', this.json);
        if (exists === '') {
            return '-';
        }
        const partyList: Object [] = this.json.issueOrderPartyRef;

        for (let i = 0; i < partyList.length; i++) {
            const casePartyRef: string = SafeJSON.get('casePartyRef', this.json.issueOrderPartyRef[i]);

            if (party.getPartyKey() === casePartyRef) {
                const field = SafeJSON.get('indexedOnDateTime', this.json.issueOrderPartyRef[i]);

                // remove this when TSD33105 is completed in WS
                /*
                  if (field !== '') {
                      if (field.indexOf('T') < 0) {
                     field = field.substring(0, 10) + 'T' + field.substring(11);
                   }
                }
                */
                // this json field might not be present for a party, so only return the value if found.
                return field;
            }
        }
        return '';
    }
    getIssueOrderPartyOrderRef(party: Party): string {
        const exists = SafeJSON.get('issueOrderPartyRef', this.json);
        if (exists === '') {
            return '-';
        }
        const partyList: Object [] = this.json.issueOrderPartyRef;

        for (let i = 0; i < partyList.length; i++) {
            const casePartyRef: string = SafeJSON.get('casePartyRef', this.json.issueOrderPartyRef[i]);
            if (party !== undefined && party.getPartyKey() === casePartyRef) {
                return SafeJSON.get('orderRef', this.json.issueOrderPartyRef[i]);
            }
        }
        return '';
    }
    getIssueOrderPartyStatus(party: any): string {
        const exists = SafeJSON.get('issueOrderPartyRef', this.json);
        if (exists === '' || party === undefined) {
            return '';
        }
        const partyList: Object [] = this.json.issueOrderPartyRef;
        const length = partyList.length;

        for (let i = 0; i < length; i++) {
            const casePartyRef: string = SafeJSON.get('casePartyRef', this.json.issueOrderPartyRef[i]);
            if (party.getPartyKey() === casePartyRef) {
                return SafeJSON.getWithDefault('issueOrderPartyStatus', this.json.issueOrderPartyRef[i]);
            }
        }
        return '';
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/issue.ts